import type {
  RadarEntry,
  RadarQuadrant,
  RadarRing,
  TechRadarLoaderResponse,
} from '@backstage-community/plugin-tech-radar-common';

const rings = new Array<RadarRing>();
rings.push({ id: 'adopt', name: 'ADOPT', color: '#93c47d' });
rings.push({ id: 'assess', name: 'ASSESS', color: '#fbdb84' });
rings.push({ id: 'hold', name: 'HOLD', color: '#efafa9' });

const quadrants = new Array<RadarQuadrant>();
quadrants.push({ id: 'infrastructure', name: 'Infrastructure' });
quadrants.push({ id: 'frameworks', name: 'Frameworks' });
quadrants.push({ id: 'languages', name: 'Languages' });
quadrants.push({ id: 'tools', name: 'Tools' });

const entries = new Array<RadarEntry>();

// Languages
entries.push(newDefinition('languages', 'adopt', 'java', 'Java'));
entries.push(
  newDefinition(
    'languages',
    'adopt',
    'javascript/typescript',
    'JavaScript/Typescript',
  ),
);
entries.push(newDefinition('languages', 'adopt', 'kotlin', 'Kotlin'));
entries.push(newDefinition('languages', 'hold', '.net', '.Net'));
entries.push(newDefinition('languages', 'hold', 'golang', 'Golang'));
entries.push(newDefinition('languages', 'assess', 'python3', 'Python 3.x'));
entries.push(newDefinition('languages', 'hold', 'scala', 'Scala'));
entries.push(newDefinition('languages', 'hold', 'python2', 'Python 2.x'));
entries.push(newDefinition('languages', 'hold', 'elixir', 'Elixir'));
entries.push(newDefinition('languages', 'hold', 'groovy', 'Groovy'));
entries.push(newDefinition('languages', 'hold', 'php', 'PHP'));
entries.push(newDefinition('languages', 'hold', 'ruby', 'Ruby'));

// Frameworks
// - Backend frameworks
entries.push(newDefinition('frameworks', 'adopt', 'springboot', 'Spring Boot'));
entries.push(newDefinition('frameworks', 'assess', 'dropwizard', 'DropWizard'));
entries.push(newDefinition('frameworks', 'assess', 'express', 'Express'));
entries.push(newDefinition('frameworks', 'assess', 'nodejs', 'Node Js'));
entries.push(
  newDefinition('frameworks', 'assess', 'ginweb', 'Gin web framework'),
);
entries.push(
  newDefinition('frameworks', 'assess', 'pythonflask', 'Python Flask'),
);
entries.push(
  newDefinition('frameworks', 'assess', 'rubyonrails', 'Ruby on Rails'),
);
entries.push(newDefinition('frameworks', 'assess', 'rxjava', 'Rx Java'));
entries.push(newDefinition('frameworks', 'assess', 'idml', 'IDML'));
entries.push(
  newDefinition('frameworks', 'hold', 'phoenixframework', 'Phoenix Framework'),
);
// - Frontend frameworks
entries.push(
  newDefinition(
    'frameworks',
    'adopt',
    'customelements',
    'Custom Elements(Html,CSS,Js Vainilla)',
  ),
);
entries.push(
  newDefinition(
    'frameworks',
    'hold',
    'fluxwebcomponents',
    'Flux Web Components',
  ),
);
entries.push(newDefinition('frameworks', 'assess', 'mui', 'MUI'));
entries.push(newDefinition('frameworks', 'hold', 'stencil', 'Stencil'));
entries.push(newDefinition('frameworks', 'assess', 'react', 'React'));
entries.push(newDefinition('frameworks', 'hold', 'vuejs', 'Vue.js'));
entries.push(newDefinition('frameworks', 'hold', 'angular', 'Angular'));
entries.push(
  newDefinition('frameworks', 'hold', 'angularjs', 'AngularJS (v1.x)'),
);
entries.push(newDefinition('frameworks', 'hold', 'ember', 'Ember'));
entries.push(newDefinition('frameworks', 'hold', 'jquery', 'jQuery'));
// - Streaming frameworks
entries.push(newDefinition('frameworks', 'adopt', 'benthos', 'Benthos'));
entries.push(
  newDefinition('frameworks', 'adopt', 'kafkastreams', 'Kakfka Streams'),
);
entries.push(
  newDefinition(
    'frameworks',
    'adopt',
    'springcloudstream',
    'Spring Cloud Stream',
  ),
);
entries.push(
  newDefinition('frameworks', 'assess', 'kakfaconnect', 'Kakfa Connect'),
);
entries.push(
  newDefinition('frameworks', 'assess', 'reactivesqs', 'Reactive SQS'),
);
entries.push(newDefinition('frameworks', 'hold', 'rxrabbit', 'RxRabbit'));

// Tools
// AI Technologies
entries.push(newDefinition('tools', 'adopt', 'claude', 'Claude'));
entries.push(newDefinition('tools', 'adopt', 'copilot', 'Copilot'));
entries.push(newDefinition('tools', 'adopt', 'openai', 'OpenAI / ChatGPT'));
entries.push(newDefinition('tools', 'assess', 'geminai', 'Geminai'));
entries.push(newDefinition('tools', 'assess', 'perplexity', 'Perplexity'));
// - Backend building tools
entries.push(newDefinition('tools', 'adopt', 'gradlebuild', 'Gradle Build'));
entries.push(newDefinition('tools', 'adopt', 'mavenbuild', 'Maven Build'));
entries.push(newDefinition('tools', 'adopt', 'npm', 'NPM'));
entries.push(newDefinition('tools', 'assess', 'pythonpip', 'Python Pip'));
entries.push(newDefinition('tools', 'assess', 'sbt', 'SBT'));
// - Testing tools
entries.push(newDefinition('tools', 'adopt', 'jest', 'Jest'));
entries.push(newDefinition('tools', 'adopt', 'junit5', 'Junit5'));
entries.push(
  newDefinition(
    'tools',
    'adopt',
    'docker-compose-e2etest',
    'Docker-compose - e2etest',
  ),
);
entries.push(newDefinition('tools', 'assess', 'cypress', 'Cypress'));
entries.push(newDefinition('tools', 'assess', 'ginkgo', 'Ginkgo'));
entries.push(newDefinition('tools', 'assess', 'puppeteer', 'Puppeteer'));
entries.push(newDefinition('tools', 'assess', 'playwright', 'Playwright'));
entries.push(newDefinition('tools', 'assess', 'spock', 'Spock'));
entries.push(
  newDefinition('tools', 'assess', 'kotlin-compose', 'Kotlin-compose'),
);
entries.push(newDefinition('tools', 'hold', 'protractor', 'Protractor'));
entries.push(newDefinition('tools', 'hold', 'junit4', 'Junit4'));
entries.push(newDefinition('tools', 'hold', 'kotlintest', 'Kotlin test'));
// - Observability tools
entries.push(newDefinition('tools', 'adopt', 'coralogix', 'Coralogix'));
entries.push(newDefinition('tools', 'adopt', 'otel', 'Open Telemetry'));
entries.push(newDefinition('tools', 'adopt', 'prometheus', 'Prometheus'));
entries.push(
  newDefinition('tools', 'assess', 'elasticsearch', 'Elasticsearch'),
);
entries.push(newDefinition('tools', 'assess', 'blundersio', 'Blunders IO'));
entries.push(
  newDefinition('tools', 'hold', 'awscloudwatch', 'AWS Cloud Watch'),
);
entries.push(newDefinition('tools', 'hold', 'datadog', 'Datadog'));
entries.push(newDefinition('tools', 'hold', 'grafana', 'Grafana'));
entries.push(newDefinition('tools', 'hold', 'kibana', 'Kibana'));
entries.push(newDefinition('tools', 'hold', 'statsd', 'Statsd'));
// - Documentation tools
entries.push(
  newDefinition('tools', 'assess', 'docs.meltwater.io', 'docs.meltwater.io'),
);
entries.push(newDefinition('tools', 'assess', 'swagger', 'Swagger'));
entries.push(
  newDefinition('tools', 'assess', 'markdown', 'MarkDown in Github'),
);
entries.push(newDefinition('tools', 'hold', 'atlassianwiki', 'Atlassian wiki'));
entries.push(newDefinition('tools', 'hold', 'googledocs', 'Google Docs'));

// Infrastructure
// - Orchestration solutions
entries.push(
  newDefinition(
    'infrastructure',
    'adopt',
    'foundationkubernetes',
    'Foundation Kubernetes',
  ),
);
entries.push(
  newDefinition('infrastructure', 'adopt', 'awslambda', 'AWS Lambda'),
);
entries.push(
  newDefinition('infrastructure', 'adopt', 'terraform', 'Terraform'),
);
entries.push(
  newDefinition('infrastructure', 'assess', 'awsbeanstalk', 'AWS Beanstalk'),
);
entries.push(newDefinition('infrastructure', 'hold', 'awsecs', 'AWS ECS'));
entries.push(
  newDefinition(
    'infrastructure',
    'hold',
    'awscloudformation',
    'AWS Cloud Formation',
  ),
);
// - CD/CI solutions
entries.push(
  newDefinition('infrastructure', 'adopt', 'githubactions', 'Github Actions'),
);
entries.push(
  newDefinition(
    'infrastructure',
    'adopt',
    'githubenterprise',
    'Github Enterprise',
  ),
);
entries.push(
  newDefinition(
    'infrastructure',
    'hold',
    'awscodepipeline',
    'AWS Code Pipeline',
  ),
);
entries.push(newDefinition('infrastructure', 'hold', 'circleci', 'Circle Ci'));
entries.push(newDefinition('infrastructure', 'hold', 'jenkins', 'Jenkins'));
entries.push(newDefinition('infrastructure', 'hold', 'travisci', 'Travis CI'));
// - Database solutions
entries.push(
  newDefinition('infrastructure', 'adopt', 'awsaurora', 'AWS Aurora'),
);
entries.push(
  newDefinition('infrastructure', 'adopt', 'awselasticache', 'AWS ElastiCache'),
);
entries.push(newDefinition('infrastructure', 'adopt', 'awsrds', 'AWS RDS'));
entries.push(newDefinition('infrastructure', 'adopt', 'awss3', 'AWS S3'));
entries.push(
  newDefinition('infrastructure', 'adopt', 'elasticsearch', 'Elasticsearch'),
);
entries.push(newDefinition('infrastructure', 'adopt', 'mysql', 'Mysql'));
entries.push(newDefinition('infrastructure', 'adopt', 'postgres', 'Postgres'));
entries.push(newDefinition('infrastructure', 'adopt', 'Redis', 'Redis'));
entries.push(
  newDefinition(
    'infrastructure',
    'assess',
    'awsauroraserverless',
    'AWS Aurora Serverless',
  ),
);
entries.push(
  newDefinition('infrastructure', 'assess', 'awsdynamodb', 'AWS DynamoDb'),
);
entries.push(
  newDefinition('infrastructure', 'assess', 'athenas3', 'Athena + S3'),
);
entries.push(
  newDefinition('infrastructure', 'assess', 'awsdynamodb', 'AWS DynamoDb'),
);
entries.push(
  newDefinition('infrastructure', 'assess', 'cassandra', 'Cassandra'),
);
entries.push(
  newDefinition(
    'infrastructure',
    'assess',
    'cassandra',
    'Cassandra (AWS Keyspaces)',
  ),
);
entries.push(
  newDefinition('infrastructure', 'assess', 'yamlgithub', 'Yaml GitHub'),
);
entries.push(newDefinition('infrastructure', 'hold', 'couchbase', 'Couchbase'));
entries.push(newDefinition('infrastructure', 'hold', 'hbase', 'Hbase'));
// - Queuing solutions
entries.push(
  newDefinition('infrastructure', 'adopt', 'apachekafka', 'Apache Kafka'),
);
entries.push(
  newDefinition(
    'infrastructure',
    'adopt',
    'awssns+awssqs',
    'AWS SNS + AWS SQS',
  ),
);
entries.push(newDefinition('infrastructure', 'adopt', 'awssqs', 'AWS SQS'));
entries.push(
  newDefinition('infrastructure', 'adopt', 'awssqs+s3', 'AWS SQS + S3'),
);
entries.push(newDefinition('infrastructure', 'assess', 'rabbitmq', 'RabbitMQ'));
entries.push(
  newDefinition('infrastructure', 'hold', 'amazonkinesis', 'Amazon Kinesis'),
);
entries.push(
  newDefinition('infrastructure', 'hold', 'beanstalkd', 'Beanstalkd'),
);
// - Api solutions
entries.push(newDefinition('infrastructure', 'adopt', 'vercel', 'Vercel'));
entries.push(
  newDefinition('infrastructure', 'adopt', 'awsapigateway', 'AWS API Gateway'),
);
entries.push(
  newDefinition(
    'infrastructure',
    'adopt',
    'k8snginxingress',
    'K8S Nginx Ingress',
  ),
);
entries.push(newDefinition('infrastructure', 'adopt', 'kong', 'Kong'));
entries.push(newDefinition('infrastructure', 'hold', 'akamai', 'Akamai'));
entries.push(
  newDefinition('infrastructure', 'hold', '3scalegateway', '3scale gateway'),
);
// - Docker container storage
entries.push(newDefinition('infrastructure', 'adopt', 'awsecr', 'AWS ECR'));
entries.push(
  newDefinition('infrastructure', 'hold', 'ghpackages', 'GitHub Packages'),
);
// -Artifact storage
entries.push(
  newDefinition(
    'infrastructure',
    'adopt',
    'jfrogartifactory2',
    'Jfrog Artifactory',
  ),
);
// - Connectors on the cloud
entries.push(
  newDefinition(
    'infrastructure',
    'adopt',
    'awstransitgateway',
    'AWS Transit Gateway',
  ),
);
entries.push(
  newDefinition('infrastructure', 'adopt', 'azurevwan', 'Azrue vWAN'),
);
entries.push(
  newDefinition(
    'infrastructure',
    'adopt',
    'engineeringawsvpn',
    'Engineering AWS VPN',
  ),
);
entries.push(
  newDefinition('infrastructure', 'hold', 'dnsoverrides', 'VPN DNS Overrides'),
);
entries.push(
  newDefinition(
    'infrastructure',
    'hold',
    'whitelistofficeips',
    'Whitelisted Office IPs',
  ),
);

export const data: TechRadarLoaderResponse = {
  entries,
  quadrants,
  rings,
};

function newDefinition(
  quadrantValue: string,
  ringValue: string,
  keyValue: string,
  titleValue: string,
): RadarEntry {
  return {
    timeline: [
      {
        moved: 0,
        ringId: ringValue,
        date: new Date('2026-04-29'),
        description: '',
      },
    ],
    url: '#',
    key: keyValue,
    id: keyValue,
    title: titleValue,
    quadrant: quadrantValue,
    description: '',
  };
}
